// @flow
import JQueryView, { on } from './JQueryView';

export default class SimulationPopupView extends JQueryView {
  constructor() {
    super('.simulation-popup');

    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('_fundoor_close_simulation_popup'))
      ?.split('=')[1];

    if (cookieValue != 'true') {
      this.$el.show();
    }
  }

  @on({ event: 'click', selector: '.close-popup i' })
  onClickClosePopup() {
    this.$el.hide();
    document.cookie = '_fundoor_close_simulation_popup=true';
  }
}
